import { OmezeniOsobSablonyE, TypZmenyEditE } from '@generated/be';
import { StatusLabel } from '@shared/utils';

export enum OpravneniTypEnum {
  IMPL_ZZ = 'IMPL_ZZ',
  IMPL_NZRA = 'IMPL_NZRA',
  EXPL = 'EXPL',
  PREZIDIALNI = 'PREZIDIALNI',
}

export enum DruhyDokladuEnum {
  ID = 'ID',
  P = 'P',
  IR = 'IR',
  VS = 'VS',
  PS = 'PS',
  OP = 'OP',
}

export const typyOpravneni: Record<OpravneniTypEnum, StatusLabel> = {
  IMPL_ZZ: {
    label: 'Implicitní ze zákona',
  },
  IMPL_NZRA: {
    label: 'Implicitní na základě rozhodnutí',
  },
  EXPL: {
    label: 'Explicitní',
  },
  PREZIDIALNI: {
    label: 'Prezidiální',
  },
};

// Volba typu subjektu u rolí (FO/PO/PFO) – DIAREZA-5723
export const omezeniOsobSablonyOptions = [
  { id: OmezeniOsobSablonyE.Fo, label: 'Fyzická osoba' },
  { id: OmezeniOsobSablonyE.Po, label: 'Právnická osoba' },
  { id: OmezeniOsobSablonyE.Pfo, label: 'Podnikající fyzická osoba' },
];

export const typyOpravneniOptions = [
  {
    id: OpravneniTypEnum.IMPL_ZZ,
    label: 'Implicitní ze zákona',
  },
  {
    id: OpravneniTypEnum.IMPL_NZRA,
    label: 'Implicitní na základě rozhodnutí',
  },
  {
    id: OpravneniTypEnum.EXPL,
    label: 'Explicitní',
  },
  {
    id: OpravneniTypEnum.PREZIDIALNI,
    label: 'Prezidiální postoupení',
  },
];

export const druhyDokladu: Record<DruhyDokladuEnum, StatusLabel> = {
  ID: {
    label: 'Občanský průkaz',
  },
  P: {
    label: 'Cestovní pas',
  },
  IR: {
    label: 'Povolení k pobytu',
  },
  VS: {
    label: 'Vízový štítek',
  },
  PS: {
    label: 'Pobytový štítek',
  },
  OP: {
    label: 'Občanský průkaz bez strojově čitelných údajů',
  },
};

export const druhyDokladuOptions = [
  {
    id: DruhyDokladuEnum.ID,
    label: 'Občanský průkaz',
  },
  {
    id: DruhyDokladuEnum.P,
    label: 'Cestovní pas',
  },
  {
    id: DruhyDokladuEnum.IR,
    label: 'Povolení k pobytu',
  },
  {
    id: DruhyDokladuEnum.VS,
    label: 'Vízový štítek',
  },
  {
    id: DruhyDokladuEnum.PS,
    label: 'Pobytový štítek',
  },
  {
    id: DruhyDokladuEnum.OP,
    label: 'Občanský průkaz bez strojově čitelných údajů',
  },
];

export const opravneniUdalosti: Record<TypZmenyEditE, StatusLabel> = {
  ZAPIS: {
    label: 'Zápis',
  },
  UKONCENI: {
    label: 'Ukončení',
  },
  ZMENA: {
    label: 'Změna',
  },
};
